<template lang="pug">
  model-form(
        :editable="editable"
        switchEdit
        ref="form"
        reset-text="limpiar"
        submit-text="Continuar"
        title="Editar promoción"
        :fields="formFields"
        v-model="formData"
        @reset="resetForm"
        @submit="submit"
        )
    template( slot="header-actions" )
      v-btn( color="primary" @click="submitUPCCode" ) código upc
          v-icon refresh
      v-btn( color="primary" @click="submitInternalCode" ) código interno
          v-icon refresh
    //- template( slot="footer-actions" )
    //-     v-btn.ml-2( color="info" block @click="submit_goOut") Guardar y salir
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
import FieldsCreate from '../../create/general/fields'
/* models */
import ProductModel from '@/models/Warehouse/WhProduct'
import PromoModel from '@/models/Warehouse/WhPromo'
import ItemModel from '@/models/Warehouse/WhItem'
/* vuex */
import {mapActions} from 'vuex'
/* services */
import Translator from '@/services/translator'
export default {
  name: 'creat-product-general-information',
  props: {
    branchOfficeId:{
      type: Array,
      required: true,
    },
    dataProduct:{
      type: Object,
      required: true,
    },
    product:{
      type: Object,
    },
    updateComponent:{
      type: Boolean,
      default: false,
    },
  },
  data: function(){
    return {
      formData: {},
      formFields: FieldsCreate(),
      //allowContinue: false,
      loadedProduct:false,
      editable:false,
    }
  },
  computed: {
    suggest_internal_code_params() {
        return {
            family_id: Number(this.formData.wh_family_id || 1),
            product_name: String(this.formData.name || ''),
            subfamily_id: Number(this.formData.wh_subfamily_id || 1),
        }
    }
  },
  methods: {
    // -- UI Modification
    // -- UPC methods
    /*
     */
    submitUPCCode() {
        this.$refs.form.setWait(true).then(this.fetchUPCCode)
    },
    fetchUPCCode() {
            ProductModel.find('suggest_upc_code')
                .then(this.setUPCCode)
                .then(this.successUPCCode)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },
    /**
     *
     */
    setUPCCode(data) {
        this.setUPCCodeItems(data)
        this.setUPCCodeValue(data)
    },

    /**
     *
     */
    setUPCCodeItems(data) {
        this.formFields[0].props.items.push(data.suggested_code)
    },

    /**
     *
     */
    setUPCCodeValue(data) {
        if(!this.formData.upc_codes){
            this.formData.upc_codes=[data.suggested_code]
        }
        else{
            this.formData['upc_codes'].push(data.suggested_code)
        }
    },
    successUPCCode() {
            this.setSnackbar({
                type: 'info',
                title: 'Código UPC',
                message: 'Se agrego el código UPC sugerido.',
                timeout: 3000,
            })
    },
    // -- End UPC methods
    // -- Internal code 
    submitInternalCode() {
      this.$refs.form.setWait(true).then(this.fetchInternalCode)
    },
    fetchInternalCode() {
      console.log(this.formData,'formData')
      console.log(this.suggest_internal_code_params,'internalcode')
      ProductModel.params((this.suggest_internal_code_params))
          .find('suggest_internal_code')
          .then(this.setInternalCode)
          .then(this.successInternalCode)
          .catch(this.error)
          .then(this.$refs.form.setWait)
    },
    setInternalCode(data) {
      this.formData['internal_code'] = data.suggested_code
    },
    successInternalCode() {
            this.setSnackbar({
                type: 'info',
                title: 'Código interno',
                message: 'Se agrego el código interno sugerido.',
                timeout: 3000,
            })
        },
    // -- End Internal code
    // -- Edit promo
    submit() {
      this.setAllowContinue(true)
      this.$refs.form.setWait(true).then(this.update)
    },
    // -- End Create product
    // -- Create and Update with empty structure.
    /* 
    */
    update(data){
      //this.$emit('generalInfo',data) 
      console.log(data,'before create')
      data.products = this.formatProductsArray(data.products)
      console.log(data , 'promo')
      // let branchData = this.getBranchOfficeData()
      // data.products = this.formatArrProducts(data.products)
      // let updateInfo = this.getUpdateInfo(data,branchData)
      // console.log(updateInfo , 'UpdateInfo')
      let model = new PromoModel({id:data.id})
      model.sync(this.formatData(data))
      .then(r=>this.responseSuccessSubmit(r))
      .catch(this.error)
      .then(this.$refs.form.setWait)
    },
    /*
     */
    formatProductsArray(products){
      return products.map(p=>{
        let newProd = {...p}
        newProd.wh_product_id = p.id
        return newProd
      })
    },

    
   
    // -- End create and Update with empty structure.
    /*
     */
    successCreateUpdate(){
      this.setSnackbar({
          type: 'success',
          title: 'Éxito',
          message: 'Información Producto creada exitosamente',
          timeout: 3000,
      })
    },
    error(error) {
      //console.log(error,'error')
            this.setSnackbar({
                type: 'error',
                title: 'Error',
                message: Translator(PromoModel, error.response.data),
                timeout: 15000,
            })
        },
    reset() {
            this.formData = new PromoModel()
            this.formFields[0].props.items = []
        },
    redirectList(){
      this.$router.push('/products')
    },
    /*
     */
    setAllowContinue(val){
      this.allowContinue = val
    },
    /*
     */
    redirectTo(data){
      if(this.allowContinue){
        // when event is emitted in the father component changes tab
        this.$emit('generalInfo',data) 
      }
      else{
        this.redirectList()
      }
    },
    /*
     */
    formatArrProducts(products){
      return products.map( p=> {
        p.wh_product_id = p.id
        return p 
      })
    },
    /*
     */
    formatData(data){
      let branch  = [...data.branch_offices]
      let format = branch.map(b=>{
        let priceOffice =data.sale_prices.find(sp=>sp.branch_office_id === b.g_branch_office_id)
        b.sale_price = priceOffice.sale_price
        return b
        // console.log(data.sale_prices,'sale_prices')
      })
      data.branch_office_data = format
      data.tags = data.tags.map(t=>(typeof t ==='object') ? t.id : t)
      return data
    }, 
    /* 
     */
    responseSuccessSubmit(response){
      this.$emit('generalInfo',response)
      this.$emit('productEdited')
      this.editable = false
      this.setSnackbar({
          type: 'success',
          title: 'Éxito',
          message: 'Información Promoción cread exitosamente',
          timeout: 3000,
      })
    },
    setFormData: async function(model) {
      model.products = this.getProductPromoTable(model)
      this.formData = {...model}
      //this.formData.products = this.getProductPromoTable(model)
      this.formData.wh_family_id = model.wh_subfamily.wh_family_id
      this.formData.tags = this.formData.wh_tags.map(t=>(typeof t ==='object') ? t.id : t)
      console.log(this.formData,'setFormData')
      //this.formData.products.push()
    },
    /*
     */
    getProductPromoTable(promo){
      if(promo === null) return[]
      //
      return this.getFormatProductPromoTable(promo.wh_products_promo) 
    },
    /*
     */
    getFormatProductPromoTable(products){
      if(products.length ===0) return null
      //
      let arrFormat = []
      products.forEach(p=>{
        let auxProduct = {...p}
        auxProduct.quantity = p.pivot.quantity
        arrFormat.push(auxProduct)
      })
      return arrFormat
    },
    // -- Data handling and transformations
    // -- Validations and Error handling
    // -- Other functions
    // -- Vuex mappings
    ...mapActions('SnackbarModalModule', {
      setSnackbar: 'setSnackbar',
    }),
  },
  watch: {
    dataProduct(val){
      if(val && this.loadedProduct===false){
        this.setFormData(this.dataProduct)
        this.loadedProduct = true
      }
    },
    updateComponent(val){
      if(val){
        this.loadedProduct = false
      }
    }
  },
  components: {
    'model-form': ModelForm,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
  mounted() {
    this.reset()
  },
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>